import { useState, useMemo } from "react";
import GameLevelToggle from "./GameLevelToggle";
import Board from "../Board/Board";
import Toggle from "../Toggle";
import ScoreBoard from "./ScoreBoard";
import MovesList from "./MovesList";
import "./Game.css";
import { LEVELS } from "../../core/computer";

export default function Game() {
  const [history, setHistory] = useState([Array(9).fill(null)]);
  const [currentMove, setCurrentMove] = useState(0);
  const [playAgainstComputer, setPlayAgainstComputer] = useState(false);
  const [gameLevel, setGameLevel] = useState(LEVELS[0]);
  const [score1, setScore1] = useState(0);
  const [score2, setScore2] = useState(0);
  const [draw, setDraw] = useState(0);

  const xIsNext = useMemo(() => currentMove % 2 === 1, [currentMove]);
  const currentSquares = history[currentMove];

  function handlePlay(nextSquares) {
    const nextHistory = [...history.slice(0, currentMove + 1), nextSquares];
    setHistory(nextHistory);
    setCurrentMove(nextHistory.length - 1);
  }

  function jumpTo(move) {
    setCurrentMove(move);
  }

  function togglePlayMode() {
    setPlayAgainstComputer((prev) => !prev);
    setDraw(0);
    setScore1(0);
    setScore2(0);
    resetBoard();
  }

  function resetBoard() {
    setHistory([Array(9).fill(null)]);
    setCurrentMove(0);
  }

  function changeGameLevel(level) {
    setGameLevel(level);
    resetBoard();
  }

  return (
    <div className="game">
      <ScoreBoard score1={score1} score2={score2} draw={draw} />

      <div className="view-order">
        <Toggle checked={playAgainstComputer} onChange={togglePlayMode} off="Jogar: com amigo" on="com Bot" />
      </div>

      {playAgainstComputer && (
        <div className="level-toggle">
          <GameLevelToggle
            labels={[
              { value: LEVELS[0], label: "Fácil", color: "#4caf50", icon: "🌱" },
              { value: LEVELS[1], label: "Ok", color: "#ffeb3b", icon: "⭐" },
              { value: LEVELS[2], label: "Brabo", color: "#ff9800", icon: "🔥" },
              { value: LEVELS[3], label: "Gênio", color: "#9c27b0", icon: "🧠" },
            ]}
            option={gameLevel}
            setOption={changeGameLevel}
          />
        </div>
      )}

      <div className="game-board">
        <Board
          playAgainstComputer={playAgainstComputer}
          xIsNext={xIsNext}
          gameLevel={gameLevel}
          squares={currentSquares}
          onPlay={handlePlay}
          newGame={resetBoard}
          setScore1={setScore1}
          setScore2={setScore2}
          setDraw={setDraw}
        />
      </div>

      <div className="game-info">
        <hr className="divider" />
        <span>Veja e estude os movimentos feitos:</span>
        <MovesList history={history} currentMove={currentMove} jumpTo={jumpTo} />
      </div>
    </div>
  );
}
